export interface LocationData {
  ip?: string;
  city: string;
  region: string;
  country: string;
  countryName: string;
  latitude: number;
  longitude: number;
  timezone: string;
  isp?: string;
  displayName?: string; // Full location display name (e.g., "Salem, Marion County, Oregon, United States")
}

export type LocationSource = 'gps' | 'ip' | 'default';

export interface LocationResult {
  location: LocationData;
  source: LocationSource;
  accuracy?: number; // GPS accuracy in meters
  error?: string;
  timestamp: number;
}

export interface GPSPosition {
  latitude: number;
  longitude: number;
  accuracy: number;
  timestamp: number;
}

export enum LocationErrorType {
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  POSITION_UNAVAILABLE = 'POSITION_UNAVAILABLE',
  TIMEOUT = 'TIMEOUT',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN = 'UNKNOWN',
}

export interface LocationError {
  type: LocationErrorType;
  message: string;
  userMessage: string;
  suggestion: string;
}
